import { Pipe, PipeTransform } from '@angular/core';
import { ContentContextType } from '@shared/enums/ContentContextType';
import { IAdvancedTemplateFooterModel } from '@shared/services/api/dashboard/advanced-templates-service/advanced-templates.model';
import { IFooterModel } from '@shared/services/api/dashboard/footers-service/footers.model';

@Pipe({
    name: 'filterFooter'
})
export class FilterFooterPipe implements PipeTransform {
    transform(footers: IFooterModel[], contextType: ContentContextType, selectedFooters: IAdvancedTemplateFooterModel[]): any {
        const filteredFooters: IFooterModel[] = [];

        selectedFooters.forEach(selectedFooter => {
            if (selectedFooter.contentContextType === contextType) {
                filteredFooters.push(footers.find(x => x.id === selectedFooter.footerId));
            }
        });

        return filteredFooters;
    }
}
